import axios from '../../network/axios'
import { INST_DETAIL, DESIG_LIST } from '../types'

const state = {
	item: [],
	designations: []
}

const actions = {
	getInstitution({ commit }, uuid) {
		return new Promise((resolve, reject) => {
			axios
				.get('/institutions/' + uuid)
				.then(({ data }) => {
					commit(INST_DETAIL, data)
					resolve(data)
				})
				.catch(() => reject())
		})
	},
	getDesignations({ commit }, institutionId) {
		return new Promise((resolve) => {
			axios
				.get('/institutions/' + institutionId + '/designations')
				.then(({ data }) => {
					commit(INST_DETAIL, { id: institutionId })
					commit(DESIG_LIST, data)
					resolve(data)
				})
		})
	},
	pickDesignation({ state }, designationId) {
		return new Promise((resolve) => {
			axios
				.post('/me/institution/' + state.item.id + '/designation', {
					designation_id: designationId
				})
				.then(({ data }) => {
					window.analytics.track('pick_project', {
						designation_id: designationId
					})
					resolve(data)
				})
		})
	}
}

const mutations = {
	[INST_DETAIL](state, institution) {
		state.item = institution
	},
	[DESIG_LIST](state, designations) {
		state.designations = designations
	}
}

export default {
	state,
	actions,
	mutations
}
